import React, { useEffect, useRef } from 'react';
import { styled } from '@mui/material/styles';
import { useParams, Switch, Route } from 'react-router-dom';
import Page from 'components/Page/Page';
// import { getContacts } from 'src/actions/chatActions';
import Sidebar from './Sidebar';
import ThreadDetails from './ThreadDetails';
import ThreadNew from './ThreadNew';

const PREFIX = 'ChatView';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledPage = styled(Page)(({ theme }) => ({
  [`&.${classes.root}`]: {
    backgroundColor: theme.palette.background.dark,
    flexGrow: 1,
    display: 'flex',
    overflow: 'hidden',
    position: 'relative',
    boxSizing: 'border-box',
  },
}));

function ChatView({ threads }) {
  const { clientId } = useParams();
  const pageRef = useRef(null);

  // useEffect(() => {
  //   dispatch(getContacts());
  // }, [dispatch]);
  return (
    <StyledPage className={classes.root} title='Chat' ref={pageRef}>
      <Sidebar containerRef={pageRef} threads={threads} />
      <Switch>
        <Route path='/m/:mid/chat/logs/:channelId/:clientId'>
          <ThreadDetails threads={threads} />
        </Route>
        <Route>
          <ThreadNew />
        </Route>
      </Switch>
    </StyledPage>
  );
}

export default ChatView;
